module.exports = __webpack_public_path__ + "img/fullscreen.974e28a4.svg";